import { Box, Grid } from "@mui/material";
import React, { useState } from "react";
import Textfield from "../../shared/textfield";


export default function ChildCommunication(props) {

  const [disabledField, setDisabledField] = useState(true);
  const handleEdit = () => {
    setDisabledField(!disabledField);
    if (!disabledField) {
      // To save changes here
    }
  };

  const handleCancelEdit = () => {
    setDisabledField(true);
  };

  const profile = props.profile;
  
  return (
    <Box ml={2} mr={2} mb={2}>
      <Grid container spacing={2}>
        {profile.childEducation?.childPersonalityInfo && profile.childEducation?.childPersonalityInfo !== "" ?
          <Grid item xs={12}>
            <Textfield
              title='Describe your child’s personality'
              value={profile.childEducation?.childPersonalityInfo}
              disabled={disabledField}
            />
          </Grid> : null}
        {profile.childEducation?.describeYourChild && profile.childEducation?.describeYourChild !== "" ?
          <Grid item xs={12}>
            <Textfield
              title='Provide three words to describe your child'
              value={profile.childEducation?.describeYourChild}
              disabled={disabledField}
            />
          </Grid> : null}
        {profile.childEducation?.childCommunicateInfo && profile.childEducation?.childCommunicateInfo !== "" ?
          <Grid item xs={12}>
            <Textfield
              title='How does your child communicate his/her wants/needs to you?'
              value={profile.childEducation?.childCommunicateInfo}
              disabled={disabledField}
            />
          </Grid> : null}
        {profile.childEducation?.childInfoComparedToOtherChildren && profile.childEducation?.childInfoComparedToOtherChildren !== "" ?
          <Grid item xs={12}>
            <Textfield
              title='How do you think your child is doing compared to other children his/her age?'
              value={profile.childEducation?.childInfoComparedToOtherChildren}
              disabled={disabledField}
            />
          </Grid> : null}
        {profile.childEducation?.favoriteThingOfYourChild && profile.childEducation?.favoriteThingOfYourChild !== "" ?
          <Grid item xs={12}>
            <Textfield
              title='Favourite thing your child does?'
              disabled={disabledField}
              value={profile.childEducation?.favoriteThingOfYourChild}
            />
          </Grid> : null}
        {profile.childEducation?.childPreferredPlay && profile.childEducation?.childPreferredPlay !== "" ?
          <Grid item xs={12}>
            <Textfield
              title='The child’s preferred play or leisure activities? Are they happy at home?'
              value={profile.childEducation?.childPreferredPlay}
              disabled={disabledField}
            />
          </Grid> : null}

      </Grid>
      {/* <Box m={2} />
      <Grid container alignItems='center' justifyContent='flex-end'>
        {!disabledField && (
          <>
            <Button
              type='submit'
              className={classes.buttonRed}
              onClick={handleCancelEdit}
            >
              Cancel
            </Button>
            <Box m={2} />
          </>
        )}
        <Button
          type='submit'
          className={classes.buttonRed}
          onClick={handleEdit}
        >
          {disabledField ? "Edit Profile" : "Save Changes"}
        </Button>
      </Grid> */}
    </Box>
  );
}
